module.exports = __webpack_public_path__ + "img/培.13444d71.png";